module.exports = __webpack_public_path__ + "img/Logos_Ajuntaments_260x260-BC.e7f31943.png";